import type { CSSProperties } from 'react';
import { C } from '@/integrations/whoop-theme';
import './about.css';

const LANGUAGES = [
  'TypeScript',
  'JavaScript',
  'Python',
  'Go',
  'Rust',
  'Java',
  'C++',
  'Ruby',
  'SQL',
  'Bash',
  'HTML',
  'CSS',
] as const;

const FRAMEWORKS = [
  'React',
  'Next.js',
  'Node.js',
  'Express',
  'FastAPI',
  'Django',
  'Flask',
  'Vue',
  'Svelte',
  'Tailwind CSS',
  'GraphQL',
  'tRPC',
  'Prisma',
] as const;

const INFRA = [
  'AWS',
  'GCP',
  'Docker',
  'Kubernetes',
  'Terraform',
  'PostgreSQL',
  'MySQL',
  'Redis',
  'Kafka',
  'Nginx',
  'GitHub Actions',
  'Grafana',
  'Prometheus',
] as const;

/**
 * The landing page (a port of the About.dc.html design): a hero with the name
 * and role, then the Languages / Frameworks / Infra chip sections.
 */
export function AboutPage() {
  return (
    <main style={{ flex: 1, width: '100%', maxWidth: 896, margin: '0 auto', padding: '0 24px' }}>
      <section
        style={{
          minHeight: '42vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          paddingTop: 48,
        }}
      >
        <div style={{ marginBottom: 18 }}>
          <span
            style={{
              fontSize: 12,
              textTransform: 'uppercase',
              letterSpacing: '0.16em',
              color: C.text2,
            }}
          >
            Software Engineer
          </span>
        </div>
        <h1
          style={{
            fontSize: 60,
            fontWeight: 700,
            lineHeight: 1.02,
            letterSpacing: '-0.025em',
            margin: 0,
          }}
        >
          Dalton Lott
        </h1>
      </section>

      <ChipSection
        id="languages"
        title="Languages"
        chips={LANGUAGES}
        style={{ paddingTop: 40, paddingBottom: 20 }}
      />
      <div style={{ borderTop: `1px solid ${C.grid}` }} />
      <ChipSection
        id="frameworks"
        title="Frameworks"
        chips={FRAMEWORKS}
        style={{ paddingTop: 32, paddingBottom: 20 }}
      />
      <div style={{ borderTop: `1px solid ${C.grid}` }} />
      <ChipSection
        id="infra"
        title="Infra"
        chips={INFRA}
        style={{ paddingTop: 32, paddingBottom: 88 }}
      />
    </main>
  );
}

function ChipSection({
  id,
  title,
  chips,
  style,
}: {
  id: string;
  title: string;
  chips: readonly string[];
  style: CSSProperties;
}) {
  return (
    <section id={id} style={style}>
      <h2 style={{ fontSize: 26, fontWeight: 600, letterSpacing: '-0.01em', margin: '0 0 20px' }}>
        {title}
      </h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {chips.map((chip) => (
          <span key={chip} className="about-chip">
            {chip}
          </span>
        ))}
      </div>
    </section>
  );
}
